<template>
  <div class="page page-login">
    <Log id="login">
      <template v-slot:default>
        <div class="banquan">
          Do not disclose your login,password and verification code to prevent fraudsters from using it. A bank employee will never ask them.
        </div>
      </template>
    </Log>
  </div>
</template>
<script>
import Log from '../../components/log/log.vue'
export default {
  name: 'Login',
  components: {
    Log
  },
  created () {

  }
}
</script>

<style scoped>
#login{
  width:5.23rem;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-40%);
}
.banquan{
width: 100%;
opacity: 0.2;
font-size: 0.14rem;
font-family: PingFangSC, PingFangSC-Medium;
font-weight: 500;
text-align: center;
color: #1d2d4e;
line-height:0.32rem;
margin-top:0.8rem;
}
</style>
